import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";
import { toast } from "react-toastify";

export const GetCustomersBIZcoreRcv = (companyId, health, page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getCustomersBIZcoreRcv(companyId, health, page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_CUSTOMERS_BIZ_CORE_RCV, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetCustomersAnalyticsBIZcoreRcv = (companyId, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getCustomersAnalyticsBIZcoreRcv(companyId);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_CUSTOMERS_ANALYTICS_BIZ_CORE_RCV, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

// Clears flags that no longer match the configuration on file. Resolves with
// the repair summary so the page can report exactly what was changed.
export const RepairCustomersBIZcoreRcv = (companyId, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.repairCustomersBIZcoreRcv(companyId);
    if (status === 201) {
      const repaired = data.data?.repaired || 0;
      toast.success(
        repaired === 0
        ? "Nothing to repair — every customer flag already matches its configuration"
        : `Repaired ${repaired} customer${repaired === 1 ? "" : "s"}`
      );
      setLoading(false);
      return data.data;
    }
    dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    setLoading(false);
    return null;
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};
